export default "__VITE_ASSET__D2j4xbuA__"